import React from 'react';

import GeneralBtn from './GeneralBtn';

const LinkBtn = ({ text = '詳細画面へ', link, ...rest }) => <GeneralBtn as="a" text={text} href={link} {...rest} />;

export default LinkBtn;
